import PalyazatModel from "../components/palyazat/Palyazat";

const Palyazat = () => {
  return <PalyazatModel />;
};

export default Palyazat;
